
























import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { PaginationModel, VHeaders } from '@/models/pagedlistmodel';
import { Team, TeamUser } from '@/models/admin/team';
import { Base } from '@/components/common/base';
import { IDialogOption } from '@/models/dialog';
import { getUserTeamListHeaders } from './team';
import { teamService } from '@/shared';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
  components: {
    Grid: () => import('@/components/common/app.grid.vue'),
    AppDialog: () => import('@/components/common/app.dialog.vue'),
  },
})
export default class UserListPage extends Base {
  public headers: VHeaders[] = getUserTeamListHeaders(this);
  public pagedTeamUsers: TeamUser[] = [];
  public pagination = new PaginationModel('teamName');
  public loading: boolean = false;
  public storeId: number = 0;
  public teamId: string = '';

  public mounted() {
    // activating tab
    this.$root.$emit('sidebar.layout.vue', 'teams');

    this.storeId = Number(this.$route.params.storeId);
    this.teamId = this.$route.params.teamId;

    // Toolbar
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });
    this.getUsers();
  }

  public actions: any[] = [
    {
      type: 'button',
      icon: 'fas fa-edit',
      title: 'Edit',
      color: 'primary',
      action: (model: TeamUser, storeId: string) => {
        this.getUserId(model);
        this.editTeams();
        // return {
        //   name: 'availability.users.edit',
        //   params: {
        //     userId: this.userToEdit.userId,
        //   },
        // };
      },
    },
    {
      type: 'button',
      icon: 'fas fa-trash-alt',
      title: this.$parent.$t(
        'teams.teamUserGridHeaders.gridAction.delete'
      ) as string,
      color: 'error',
      action: (model: TeamUser, storeId: string) => {
        this.confirmDelete(model);
      },
    },
  ];

  public editTeams(): any {
    this.$router.push({
      name: 'availability.users.edit',
      params: {
        userId: this.userToEdit.userId,
      },
    });
  }

  public userToEdit: TeamUser = {
    userId: '',
    userEmail: '',
  };

  public getUserId(id) {
    this.userToEdit.userId = id.userId;
  }

  public deleteDialog: IDialogOption = {
    width: 400,
    title: this.$parent.$t('teams.deleteDialogTitle') as string,
    model: false,
    action: { color: 'success', icon: 'fas fa-check', text: 'Agree' },
    loading: false,
    onAction: (): void => {
      this.deleteTeam();
    },
  };

  public teamUserToDelete: TeamUser = {
    userId: '',
    userEmail: '',
  };

  public preventPaginationCall: boolean = false;

  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }
  public callMethod(methodName): void {
    if (methodName === 'addUser') {
      this.$router.push({
        name: 'admin.teams.users.add',
        params: {
          teamId: this.teamId.toString(),
          storeId: this.storeId.toString(),
        },
      });
    } else if (methodName === 'backToTeam') {
      this.$router.push({
        name: 'admin.teams',
        params: { storeId: this.storeId.toString() },
      });
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    buttons.push({
      id: '0',
      type: 'button',
      title: this.$t('teams.btnBack'),
      disabled: false,
      visible: true,
      class: 'btn',
      label: this.$t('teams.btnBack'),
      click: 'backToTeam',
      icon: 'fas fa-arrow-left',
    });

    buttons.push({
      id: '1',
      type: 'button',
      title: this.$t('teams.btnAddTeamUser'),
      disabled: false,
      visible: true,
      class: 'btn',
      label: this.$t('teams.btnAddTeamUser'),
      click: 'addUser',
      icon: 'fas fa-plus-circle',
    });
    this.$emit('updateToolBar', buttons);
  }

  public async getUsers(): Promise<void> {
    try {
      this.loading = true;
      const response = await teamService.getTeamUsers(
        this.teamId,
        this.storeId,
        this.pagination
      );
      this.pagedTeamUsers = response.results;
      this.pagination.totalItems = response.total;
    } finally {
      this.loading = false;
    }
  }

  public updatePaging(paging: any) {
    this.pagination = paging;
  }
  public confirmDelete(item: TeamUser): void {
    this.deleteDialog.model = true;
    this.teamUserToDelete = item;
  }
  public async deleteTeam(): Promise<void> {
    try {
      this.deleteDialog.loading = true;
      await teamService.deleteUser(
        this.teamId,
        this.teamUserToDelete.userId,
        this.storeId
      );
      this.deleteDialog.model = false;
      this.preventPaginationCall = true;
      this.showAlert(true, this.$parent.$t('teams.alertDeleteTeamUser'));
      this.getUsers();
    } finally {
      this.deleteDialog.loading = false;
    }
  }
}
